// removed by extract-text-webpack-plugin
module.exports = {"xxs":"src-components-commons-Whitespace-style----size-module---xxs---3RESH padding-xxs","xs":"src-components-commons-Whitespace-style----size-module---xs---2byis padding-xs","s":"src-components-commons-Whitespace-style----size-module---s---1a1T0 padding-s","m":"src-components-commons-Whitespace-style----size-module---m---RP29m padding-m","l":"src-components-commons-Whitespace-style----size-module---l---H-TlE padding-l","xl":"src-components-commons-Whitespace-style----size-module---xl---iPbJ- padding-xl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/commons/Whitespace/style/size.module.css
// module id = 1432
// module chunks = 168707334958949